<div class="data-table-frame" [class.frameless]="$frameless()">
    <div class="data-table-scroll">
        <table [style.min-width]="$minWidth()">
            <colgroup>
                @if ($selectable()) { <col class="col-select" /> }
                @for (col of $columns(); track col.id) {
                    <col [style.width]="col.width ?? null" />
                }
            </colgroup>
            <thead [class.sticky]="$stickyHeader()">
                <tr>
                    @if ($selectable()) {
                        <th class="cell-select" scope="col"></th>
                    }
                    @for (col of $columns(); track col.id) {
                        <th scope="col" [class.align-right]="col.align === 'right'">{{ col.header }}</th>
                    }
                </tr>
            </thead>
            <tbody>
                @for (row of $rows(); track $getRowId()(row)) {
                    <tr [class]="rowClassOf(row)" [class.selected]="isSelected(row)" [class.clickable]="$rowClickHandled()" [attr.tabindex]="$rowClickHandled() ? 0 : null" [attr.aria-selected]="$selectable() ? isSelected(row) : null" (click)="onRowClick(row)" (keydown)="onRowKeydown($event, row)">
                        @if ($selectable()) {
                            <td class="cell-select" (click)="$event.stopPropagation()">
                                <wb-checkbox [checked]="isSelected(row)" (onToggle)="toggleRow(row)" [attr.aria-label]="'Select row'" />
                            </td>
                        }
                        @for (col of $columns(); track col.id) {
                            <td [class.align-right]="col.align === 'right'" [class.wrap]="col.wrap" [attr.title]="col.tooltip ? cellValue(row, col) : null">
                                @if ($templateByColumn().get(col.id); as tpl) {
                                    <ng-container *ngTemplateOutlet="tpl; context: { $implicit: row, column: col }" />
                                } @else {
                                    <span>{{ cellValue(row, col) }}</span>
                                }
                            </td>
                        }
                    </tr>
                }
            </tbody>
        </table>
        @if (!$rows().length) {
            <div class="data-table-empty"><ng-content select="[dataTableEmpty]" /></div>
        }
    </div>
</div>
